import axios from "axios";
import { getEnvironment } from "../utils/getEnvironment";
import Color from "../modules/Color";

const environment = getEnvironment();

export type BrandCreationResponse = {
    brand: string;
    location: string;
    slug: string;
};

export default class Brand {
    public static readonly validate = async (params: {
        name?: string;
        address?: string;
    }): Promise<{ nameTaken?: boolean; addressTaken?: boolean }> => {
        const query = new URLSearchParams();
        if (params.name) query.append("name", params.name);
        if (params.address) query.append("address", params.address);

        const res = await axios.get(
            `${environment.api_url}/brand/validate?${query.toString()}`
        );
        return res.status === 200 ? res.data : {};
    };

    public static readonly count = async () =>
        (
            await axios
                .get(environment.api_url + "/business/count")
                .then((res) => (res.status === 200 ? res.data : undefined))
                .catch(console.error)
        )?.count as number | undefined;

    public static readonly register = async (
        uuid: string,
        name: string,
        address: string,
        color: Color,
        description: string,
        business_id: string,
        logo?: string,
        refBrandAddress?: string
    ): Promise<Brand> => {
        try {
            const res = await axios.post(
                environment.api_url + "/brand",
                {
                    name,
                    address,
                    colorRed: color.r,
                    colorGreen: color.g,
                    colorBlue: color.b,
                    description,
                    business: business_id,
                    logo,
                    affiliatedFromAddress: refBrandAddress || undefined,
                },
                {
                    headers: {
                        "User-Token": uuid,
                    },
                }
            );

            return res.data; // This is safe — Axios throws on non-2xx
        } catch (err) {
            console.error("Brand.register failed:", err);
            throw err;
        }
    };

    public static readonly registerNew = async (
        name: string,
        address: string,
        color: Color,
        business_id: string,
        logo?: string,
        refBrandAddress?: string
    ): Promise<BrandCreationResponse> => {
        try {
            const res = await axios.post(environment.api_url + "/brand/beta", {
                name,
                address,
                colorRed: color.r,
                colorGreen: color.g,
                colorBlue: color.b,
                logo: logo,
                business: business_id,
                affiliatedFromAddress: refBrandAddress || undefined,
            });

            return res.data; // This is safe — Axios throws on non-2xx
        } catch (err) {
            console.error("Brand.register failed:", err);
            throw err;
        }
    };
}
